import {
  DeleteFileDocument,
  GetFileDocument,
  GetFileStatisticsDocument,
  ListFilesDocument,
  UploadFileMultiPartDocument,
} from './generated/graphql'
import { createMutationHelper, createQueryHook, modifyQueryHook } from './utils'

export const useListFiles = modifyQueryHook(
  createQueryHook(ListFilesDocument),
  {
    reduce: r => r?.files,
  },
)

export const useGetFile = modifyQueryHook(createQueryHook(GetFileDocument), {
  transform: (id: string) => ({ id }),
  reduce: res => res?.fileUploadRecord,
})

export const useGetFileStatistics = modifyQueryHook(
  createQueryHook(GetFileStatisticsDocument),
  {
    reduce: res => res?.fileStatistics,
  },
)

export const [useDeleteFile, executeDeleteFile] =
  createMutationHelper(DeleteFileDocument)

export const [useUploadFileMultiPart, executeUploadFileMultiPart] =
  createMutationHelper(UploadFileMultiPartDocument)
